import { Badge } from '@flipster/react/design-system/badge';
import ChatBubbleDoubleIcon from '@flipster/react/icon/generated/ChatBubbleDoubleIcon';
import ThumbDownIcon from '@flipster/react/icon/generated/ThumbDownIcon';
import ThumbUpIcon from '@flipster/react/icon/generated/ThumbUpIcon';
import TrendIcon from '@flipster/react/icon/generated/TrendIcon';
import { Styles, css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import type { NormalizedKolIndicators } from '../helpers';

interface KolInsightIndicatorIconsProps {
  indicators: NormalizedKolIndicators;
  css?: Styles;
}

/** Fixed-height row for sentiment + isHot (icon-only). Buzz is detail-only. */
export const KolInsightIndicatorIcons = ({ indicators, css: cssProps }: KolInsightIndicatorIconsProps) => {
  const { isHot, sentiment } = indicators;

  return (
    <div className={css(hstack.raw({ gap: 4, h: 20, alignItems: 'center' }), cssProps)}>
      {sentiment === 'positive' && <Badge type='tint' color='positive' leadingIcon={<ThumbUpIcon />} aria-hidden />}
      {sentiment === 'negative' && <Badge type='tint' color='negative' leadingIcon={<ThumbDownIcon />} aria-hidden />}
      {sentiment === 'mixed' && (
        <Badge type='tint' color='neutral' leadingIcon={<ChatBubbleDoubleIcon />} aria-hidden />
      )}
      {/* Same Badge frame; not a tint variant — clear surface via CSS var override. */}
      {isHot && (
        <Badge
          leadingIcon={<TrendIcon />}
          css={{
            '--badge-background-color': 'colors.background.default.level-1',
            '--badge-border-color': 'transparent',
            color: 'content.accent.new',
          }}
          aria-hidden
        />
      )}
    </div>
  );
};
